"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeAccount = exports.normalizeChainId = void 0;
const bytes_1 = require("@ethersproject/bytes");
const keccak256_1 = require("@ethersproject/keccak256");
const tiny_invariant_1 = __importDefault(require("tiny-invariant"));
function normalizeChainId(chainId) {
    if (typeof chainId === "string") {
        // Temporary fix until the next version of Metamask Mobile gets released.
        // In the current version (0.2.13), the chainId starts with “Ox” rather
        // than “0x”. Fix: https://github.com/MetaMask/metamask-mobile/pull/1275
        chainId = chainId.replace(/^Ox/, "0x");
        const parsedChainId = Number.parseInt(chainId, chainId.trim().substring(0, 2) === "0x" ? 16 : 10);
        (0, tiny_invariant_1.default)(!Number.isNaN(parsedChainId), `chainId ${chainId} is not an integer`);
        return parsedChainId;
    }
    else {
        (0, tiny_invariant_1.default)(Number.isInteger(chainId), `chainId ${chainId} is not an integer`);
        return chainId;
    }
}
exports.normalizeChainId = normalizeChainId;
// https://github.com/ethers-io/ethers.js/blob/d9d438a119bb11f8516fc9cf02c534ab3816fcb3/packages/address/src.ts/index.ts
function normalizeAccount(_address) {
    (0, tiny_invariant_1.default)(typeof _address === "string" && _address.match(/^(0x)?[0-9a-fA-F]{40}$/), `Invalid address ${_address}`);
    const address = _address.substring(0, 2) === "0x" ? _address : `0x${_address}`;
    const chars = address.toLowerCase().substring(2).split("");
    const charsArray = new Uint8Array(40);
    for (let i = 0; i < 40; i++) {
        charsArray[i] = chars[i].charCodeAt(0);
    }
    const hashed = (0, bytes_1.arrayify)((0, keccak256_1.keccak256)(charsArray));
    for (let i = 0; i < 40; i += 2) {
        if (hashed[i >> 1] >> 4 >= 8) {
            chars[i] = chars[i].toUpperCase();
        }
        if ((hashed[i >> 1] & 0x0f) >= 8) {
            chars[i + 1] = chars[i + 1].toUpperCase();
        }
    }
    const addressChecksum = `0x${chars.join("")}`;
    (0, tiny_invariant_1.default)(!(address.match(/([A-F].*[a-f])|([a-f].*[A-F])/) && address !== addressChecksum), `Bad address checksum ${address} ${addressChecksum}`);
    return addressChecksum;
}
exports.normalizeAccount = normalizeAccount;
